




















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {
  AppUserRightEditModel,
  ProjectFilter,
  ProjectStaffEditModel, RightEnum,
  StSelectListItemGroup
} from '@/services/api/nswag/stapiclient_generated';
import {stProjectApi} from '@/services/st-api';
import { has } from "lodash";

@Component({
  methods: { has },
  components: {},
})
export default class AppUserProjectStaffEdit extends Vue {
  @Prop() value!: ProjectStaffEditModel[];
  @Prop() appUserId!: number;
  @Prop() canViewTimeEntriesForEmployeesGlobal!: boolean;
  @Prop() canEditTimeEntriesForEmployeesGlobal!: boolean;
  @Prop() hasRightAllProjects!: boolean;

  projects: StSelectListItemGroup[] = [];
  loading = false;
  assignedProjectId: number = 0;

  get assignedProjects(): StSelectListItemGroup[] {
    let res: StSelectListItemGroup[] = [];

    for (let customer of this.projects) {
      let selectedProjects = customer.items?.filter(x => this.editModels.map(y => y.projectId).some(y => y == x.id)) ?? [];

      if (selectedProjects.length) {
        res.push({groupName: customer.groupName, items: selectedProjects} as StSelectListItemGroup);
      }
    }

    return res;
  }

  get unassignedProjects(): StSelectListItemGroup[] {
    let res: StSelectListItemGroup[] = [];

    for (let customer of this.projects) {
      let unselectedProjects = customer.items?.filter(x => !this.editModels.map(y => y.projectId).some(y => y == x.id)) ?? [];

      if (unselectedProjects.length) {
        res.push({groupName: customer.groupName, items: unselectedProjects} as StSelectListItemGroup);
      }
    }

    return res;
  }

  get editModels() {
    return this.value;
  }

  set editModels(data: ProjectStaffEditModel[]) {
    this.$emit('input', data);
  }

  async mounted() {
    try {
      this.loading = true;
      this.projects = await stProjectApi.getSelectListForProjectAssignment(ProjectFilter.fromJS({}));
    } finally {
      this.loading = false;
    }
  }

  canViewTimeEntriesEmployee(projectId: number) {
    return this.editModels.find(x => x.projectId == projectId)?.canViewAllProjectTimeEntries;
  }

  canEditTimeEntriesEmployee(projectId: number) {
    return this.editModels.find(x => x.projectId == projectId)?.canEditAllProjectTimeEntries;
  }

  toggleCanViewTimeEntriesEmployee(projectId: number) {
    let currentVal = this.editModels.find(x => x.projectId == projectId)!.canViewAllProjectTimeEntries;

    this.editModels.find(x => x.projectId == projectId)!.canViewAllProjectTimeEntries = !currentVal;
  }

  toggleCanEditTimeEntriesEmployee(projectId: number) {
    let currentVal = this.editModels.find(x => x.projectId == projectId)!.canEditAllProjectTimeEntries;

    this.editModels.find(x => x.projectId == projectId)!.canEditAllProjectTimeEntries = !currentVal;

    if(this.canEditTimeEntriesEmployee(projectId) && !this.canViewTimeEntriesEmployee(projectId)){
      this.toggleCanViewTimeEntriesEmployee(projectId);
    }
  }

  unassignProject(projectId: number) {
    this.editModels.splice(this.editModels.findIndex(x => x.projectId == projectId), 1);
  }

  assignProject() {
    let newItem: ProjectStaffEditModel = ProjectStaffEditModel.fromJS({
      projectId: this.assignedProjectId,
      appUserId: this.appUserId,
      canViewAllProjectTimeEntries: false
    });

    this.editModels.push(newItem);

    this.assignedProjectId = 0;
  }
}
